import { render, staticRenderFns } from "./paychecks-new.vue?vue&type=template&id=88190ece&scoped=true&"
import script from "./paychecks-new.vue?vue&type=script&lang=ts&"
export * from "./paychecks-new.vue?vue&type=script&lang=ts&"
import style0 from "./paychecks-new.vue?vue&type=style&index=0&id=88190ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88190ece",
  null
  
)

export default component.exports